module.exports = __webpack_public_path__ + "static/img/document.d868b29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/document.png
// module id = H0Vl
// module chunks = 2